import React, { useState } from 'react';
import { StatCard } from './StatCard';
import { ActivityFeed } from './ActivityFeed';
import { AddInspirationModal } from './AddInspirationModal';
import { Button } from './ui/Button';
import { Plus, Lightbulb, Video, Sparkles, TrendingUp } from 'lucide-react';
export function Dashboard() {
  const [isAddInspirationOpen, setIsAddInspirationOpen] = useState(false);
  const handleAddInspiration = (inspiration: any) => {
    console.log('New inspiration added:', inspiration);
    // TODO: Add to swipefile list
  };
  return <>
      <div className="flex-1 h-full flex flex-col bg-gray-50/50 overflow-auto" data-id="element-393">
        {/* Header */}
        <div className="bg-white border-b px-8 py-6" data-id="element-394">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-395">
            <div data-id="element-396">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-397">Dashboard</h1>
              <p className="text-gray-500 mt-1" data-id="element-398">
                Welcome back! Here's your content overview
              </p>
            </div>
            <div className="flex gap-3" data-id="element-399">
              <Button className="bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 shadow-sm gap-2" onClick={() => setIsAddInspirationOpen(true)} data-id="element-400">
                <Video className="h-4 w-4" data-id="element-401" />
                Add Inspiration
              </Button>
              <Button className="bg-[#139191] hover:bg-[#139191]/90 text-white shadow-md gap-2" data-id="element-402">
                <Lightbulb className="h-4 w-4" data-id="element-403" />
                New Idea
              </Button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-8" data-id="element-404">
          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-405">
            <StatCard title="Total Inspirations" value="247" icon={Video} trend="+12 this week" trendUp={true} data-id="element-406" />
            <StatCard title="Ideas in Progress" value="18" icon={Lightbulb} trend="5 active today" trendUp={true} data-id="element-407" />
            <StatCard title="Concepts Created" value="64" icon={Sparkles} trend="+8 this month" trendUp={true} data-id="element-408" />
          </div>

          {/* Activity Feed and Quick Actions */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-409">
            {/* Activity Feed - Takes 2 columns */}
            <div className="lg:col-span-2" data-id="element-410">
              <ActivityFeed data-id="element-411" />
            </div>

            {/* Quick Actions Panel */}
            <div className="space-y-6" data-id="element-412">
              <div className="bg-gradient-to-br from-[#139191] to-[#0d7070] rounded-lg p-6 text-white" data-id="element-413">
                <div className="flex items-center gap-2 mb-3" data-id="element-414">
                  <TrendingUp className="h-5 w-5" data-id="element-415" />
                  <h3 className="font-bold text-lg" data-id="element-416">Quick Stats</h3>
                </div>
                <div className="space-y-3" data-id="element-417">
                  <div className="flex justify-between items-center" data-id="element-418">
                    <span className="text-sm text-white/80" data-id="element-419">This Week</span>
                    <span className="font-bold text-xl" data-id="element-420">32</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-421">
                    <span className="text-sm text-white/80" data-id="element-422">This Month</span>
                    <span className="font-bold text-xl" data-id="element-423">128</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-424">
                    <span className="text-sm text-white/80" data-id="element-425">All Time</span>
                    <span className="font-bold text-xl" data-id="element-426">329</span>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-427">
                <h3 className="font-bold text-lg mb-4 text-gray-900" data-id="element-428">
                  Quick Actions
                </h3>
                <div className="space-y-3" data-id="element-429">
                  <Button className="w-full justify-start gap-3 bg-[#139191] hover:bg-[#139191]/90 text-white" onClick={() => setIsAddInspirationOpen(true)} data-id="element-430">
                    <Plus className="h-4 w-4" data-id="element-431" />
                    Add New Video
                  </Button>
                  <Button variant="outline" className="w-full justify-start gap-3 border-gray-200 text-gray-700 hover:bg-gray-50" data-id="element-432">
                    <Lightbulb className="h-4 w-4" data-id="element-433" />
                    Create Idea
                  </Button>
                  <Button variant="outline" className="w-full justify-start gap-3 border-gray-200 text-gray-700 hover:bg-gray-50" data-id="element-434">
                    <Sparkles className="h-4 w-4" data-id="element-435" />
                    New Concept
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Inspiration Modal */}
      <AddInspirationModal isOpen={isAddInspirationOpen} onClose={() => setIsAddInspirationOpen(false)} onSubmit={handleAddInspiration} data-id="element-436" />
    </>;
}